module.exports = __webpack_public_path__ + "assets/img/db4ad58e949f99f94c1379e545909f89.png";